import { HttpClient } from '@shared/adapters/HttpClient';

export interface CreatePreparationRequest {
    ids: number[];
    preparation_type: number;
}

export interface CreatePreparationResponse {
    success?: boolean;
    message?: string;
    preparation_id?: number;
}

export class PreparationApiAdapter {
    constructor(private httpClient: HttpClient) { }

    async createPreparation(request: CreatePreparationRequest): Promise<CreatePreparationResponse> {
        const response = await this.httpClient.put<CreatePreparationResponse>(
            '/orders/mark-as-preparation',
            request
        );
        return response;
    }
} 